module.exports = __webpack_public_path__ + "static/media/play.026f8cde.svg";